<li class="item" [class.item-active]="active" [class.sub-menu]="isSubMenu">
  <span #item *ngIf="!label" class="premium">
    <ng-content select="[slot=item]"></ng-content>
  </span>

  <span *ngIf="label" [class]="product">
    {{ label }}
  </span>
</li>
